import React, { useState, useEffect } from "react";
import {
  getAllAppointmentsByEmail,
  deleteAppointment,
  updateAppointment,
  getDoctorTimeSlots,
  getDoctorById,
} from "../backend"; // Make sure `updateAppointment` is implemented in backend
import "../Style/AppointmentDetail.css";
import axios from "axios";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useAuth } from "./UserContext.js";
import { useAppointment } from "./AppointmentContext.js";

const AppointmentDetail = () => {
  const { currentUser } = useAuth();
  const { handleAppointment } = useAppointment();
  const [appointments, setAppointments] = useState([]);
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  const [locations, setLocations] = useState([]);
  const [showLocation, setShowLocations] = useState("");
  const [appointmentDoctorId, setAppointmentDcotorId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocation, setSelectedLocations] = useState("Select Location");
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [newTime, setNewTime] = useState("");
  const [newDate, setNewDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedTime, setSelectedTime] = useState("");
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [appointmentToCancel, setAppointmentToCancel] = useState(null);
  const [disabledSlots, setDisabledSlots] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [currentDoctor, setCurrentDoctor] = useState([]);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [appointmentToEdit, setAppointmentToEdit] = useState(null);
  const [doctorId, setDoctorId] = useState("");
  const user = Array.isArray(currentUser)
    ? currentUser[currentUser.length - 1]
    : currentUser;

  useEffect(() => {
    fetchDoctorTimeSlots(doctorId, newDate, selectedLocation);
  }, [selectedLocation, newDate]);

  const fetchDoctorTimeSlots = async (doctorId, date, selectedLocation) => {
    try {
      const response = await getDoctorTimeSlots(
        doctorId,
        date,
        selectedLocation
      );
      console.log("Fetch Rep", response);
      if (!response) {
        setTimeSlots([]);
      }
      // setStartDate(formatDateForInput(response.schedule[0].startDate));
      const slots = response.slots;
      const disabled = slots
        .filter(
          (slot) => slot.status === "booked" || slot.status === "unavailable"
        )
        .map((slot) => slot.time);
      setTimeSlots(slots);
      setDisabledSlots(disabled);
    } catch (error) {
      console.error("Error fetching time slots:", error);
    }
  };

  let filteredLocation = [];
  if (currentDoctor) {
    filteredLocation = locations?.filter((p) =>
      p.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  useEffect(() => {
    if (!user?.email) return;
    fetchAppointments();
  }, [user]);

  const fetchAppointments = async () => {
    let orderData = [];
    try {
      const response = await getAllAppointmentsByEmail(user.email);
      response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      response.map((res) => {
        console.log("Res", res);
        orderData.push(res.orderDetails || {});
      });
      setOrders(orderData);
      setAppointments(response || []);
    } catch (err) {
      console.error("Error fetching appointments:", err);
      setError(err.message);
    }
  };

  const handleDeleteConfirm = async () => {
    if (!appointmentToCancel) return;
    const res = await deleteAppointment(
      currentUser?.userId,
      appointmentToCancel
    );
    if (res) {
      alert("Appointment Cancelled Successfully.");
      fetchAppointments();
    } else {
      alert("Failed to delete appointment.");
    }
    setShowCancelPopup(false);
    setAppointmentToCancel(null);
  };
  const formatDateForInput = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };
  const handleShowEditPopup = async (doctorId) => {
    const doctor = await getDoctorById(doctorId);
    console.log("Doctor deta", doctor);
    if (doctor) {
      setLocations(doctor.doctor.locations);
      setShowEditPopup(true);
    }
  };
  const handleEditSubmit = async () => {
    if (!appointmentToEdit || !newDate || !selectedTime) return;
    let obj = {
      selectedLocation,
      appointmentToEdit,
      newDate,
      selectedTime,
    };

    try {
      const res = await updateAppointment(
        selectedLocation,
        appointmentToEdit,
        newDate,
        selectedTime
      );
      console.log("Res", res);

      if (res) {
        alert("Appointment updated successfully.");
        fetchAppointments();
      } else {
        alert("Failed to update appointment.");
      }
    } catch (error) {
      console.error("Update error:", error);
      alert("Something went wrong.");
    }
    setShowEditPopup(false);
    setAppointmentToEdit(null);
  };

  const handlePayment = async (amount, order) => {
    amount = amount * 100; // Convert to cents/paise
    try {
      // let url = "http://localhost:8081/api/payment/create-order";
      let url = "https://apirk.drrkvishwakarma.com/api/payment/create-order";
      axios
        .post(`${url}`, {
          pharmacyId: order.pharmacyId,
          orderId: order.orderId,
          amount,
        })
        .then((response) => {
          window.location.href = response.data.checkoutPageUrl;
        })
        .catch((error) => {
          console.log(error);
          alert("Failed to create payment order.");
        });
    } catch (error) {
      console.log("Error", error);
      alert("Payment initiation failed.");
    }
  };

  const isWithinFourHours = (appointment) => {
    if (!appointment?.date || !appointment?.startTime) return false;

    // Use current date if the appointment date is today, otherwise use the appointment date
    // Note: The logic here assumes the `appointment.date` is in a YYYY-MM-DD format if not used with `new Date()`
    const appointmentDateTime = new Date(
      `${appointment.date} ${appointment.startTime}`
    );
    const now = new Date();

    const timeDiff = appointmentDateTime - now; // difference in ms

    // 4 hours in ms
    return timeDiff > 0 && timeDiff <= 4 * 60 * 60 * 1000;
  };

  return (
    <div className="appointment-detail-page">
      <h1 className="appointment-details-h1" style={{ textAlign: "center" }}>
        My Appointments
      </h1>

      <div className="appointment-content-div">
        {appointments.length > 0 ? (
          appointments.map((appointment, index) => {
            const matchingOrder = orders.find(
              (order) => order.appointmentId === appointment.appointmentId
            );

            // Calculate the final price for display and payment
            let finalTotalPrice = 0;
            if (matchingOrder) {
              const basePrice = parseFloat(matchingOrder.totalPrice || 0);
              const fee = parseFloat(matchingOrder.additionalFee || 0);
              finalTotalPrice = basePrice + fee;
            }

            return (
              <div key={index} className="appointment-ul-content">
                <li>
                  <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                    Patient Id:
                  </strong>{" "}
                  {appointment.userId}
                </li>
                <li>Appointment Id: {appointment.appointmentId}</li>
                <li>
                  <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                    {appointment.firstName} {appointment.lastName}
                  </strong>{" "}
                  - {appointment.email}
                </li>
                <li>{appointment.phoneNumber}</li>
                <li>
                  <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                    Doctor Email:
                  </strong>
                  {`${appointment.doctorEmail}`}
                </li>
                <li>
                  <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                    Doctor Name:
                  </strong>
                  {`${appointment.doctorName || "NA"}`}
                </li>
                <li>{appointment.location}</li>
                <li>
                  <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                    Appointment Date:
                  </strong>
                  {`${appointment.date}`}
                </li>
                <li>
                  <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                    Appointment Status:
                  </strong>
                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      color:
                        appointment.appointmentStatus === "Expired" ||
                        appointment.appointmentStatus === "Cancelleds"
                          ? "red"
                          : appointment.appointmentStatus === "Completed"
                          ? "green"
                          : "orange",
                    }}
                  >{`${appointment.appointmentStatus}`}</p>
                </li>
                <li>
                  <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                    Time:
                  </strong>
                  {`${appointment.startTime}`}
                </li>

                {(appointment.appointmentStatus === "Booked" ||
                  (appointment.appointmentStatus !== "Completed" &&
                    appointment.appointmentStatus !== "Expired")) && (
                  <div className="appointment-btn">
                    <button
                      disabled={isWithinFourHours(appointment)}
                      style={{
                        opacity: isWithinFourHours(appointment) ? 0.5 : 1,
                        cursor: isWithinFourHours(appointment)
                          ? "not-allowed"
                          : "pointer",
                      }}
                      onClick={() => {
                        if (isWithinFourHours(appointment)) return;
                        setAppointmentToEdit(appointment.appointmentId);
                        handleShowEditPopup(appointment.doctorId);
                        setNewTime(appointment.startTime);
                        setDoctorId(appointment.doctorId);
                      }}
                    >
                      Edit
                    </button>

                    <button
                      disabled={isWithinFourHours(appointment)}
                      style={{
                        opacity: isWithinFourHours(appointment) ? 0.5 : 1,
                        cursor: isWithinFourHours(appointment)
                          ? "not-allowed"
                          : "pointer",
                      }}
                      onClick={() => {
                        if (isWithinFourHours(appointment)) return;
                        setAppointmentToCancel(appointment.appointmentId);
                        setShowCancelPopup(true);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}

                {/* UPDATED LOGIC START 
                  1. Display finalTotalPrice (totalPrice + additionalFee)
                  2. Show "Pay Now" button if paymentStatus is NOT "Completed"
                */}
                {appointment.appointmentStatus === "Completed" &&
                matchingOrder ? (
                  <>
                    <p className="price-info">
                      <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                        Order Total Price:
                      </strong>{" "}
                      {`₹${finalTotalPrice.toFixed(2)}`}
                      {/* Optional: Show breakdown if there's an additional fee
                      {parseFloat(matchingOrder.additionalFee) > 0 &&
                        ` (Includes Fee: ₹${parseFloat(
                          matchingOrder.additionalFee
                        ).toFixed(2)})`} */}
                    </p>

                    {matchingOrder.paymentStatus !== "Completed" ? (
                      <div
                        className="appointment-btn"
                        style={{ marginTop: "10px" }}
                        onClick={() => {
                          // Use the calculated final total price for payment
                          handlePayment(finalTotalPrice, matchingOrder);
                        }}
                      >
                        {/* The "Pay Now" button will now show if paymentStatus is not Completed */}
                        <button>Pay Now </button>
                      </div>
                    ) : (
                      // Payment is completed
                      <>
                        <p className="price-info">
                          {`Order Payment Mode: ${
                            matchingOrder.paymentMode || "NA"
                          }`}
                        </p>
                        <p className="price-info">
                          {`Order Status: ${matchingOrder.orderStatus}`}
                        </p>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {appointment.appointmentStatus === "Completed" && (
                      <p className="order-status">
                        {`Order Status: ${
                          matchingOrder ? matchingOrder.orderStatus : "Pending"
                        }`}
                      </p>
                    )}
                  </>
                )}
                {matchingOrder && matchingOrder.orderStatus === "Completed" && (
                  <div className="appointment-btn1">
                    <button onClick={() => handleAppointment(appointment)}>
                      Re-Appointment
                    </button>
                  </div>
                )}
                {/* UPDATED LOGIC END */}
              </div>
            );
          })
        ) : (
          <p className="no-appointment-1">No Appointments Found.</p>
        )}
      </div>

      {/* Cancel Confirmation Popup */}
      {showCancelPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <p>
              Your appointment fee will not be refunded. Still want to cancel?
            </p>
            <div className="popup-btns">
              <button onClick={handleDeleteConfirm}>Yes</button>
              <button
                onClick={() => {
                  setShowCancelPopup(false);
                  setAppointmentToCancel(null);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Appointment Popup */}
      {showEditPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Edit Appointment</h3>
            <div className="custom-dropdown-container-1">
              <label>Select Location</label>
              <div className="custom-dropdown-container">
                {showLocation ? (
                  <input
                    type="text"
                    placeholder="Search Location"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    autoFocus
                  />
                ) : (
                  <p>{selectedLocation}</p>
                )}
                <MdKeyboardArrowDown
                  size={25}
                  onClick={() => {
                    setShowLocations(!showLocation);
                  }}
                  style={{
                    transform: showLocation ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
              {showLocation && (
                <div
                  className="custom-dropdown-container-drop"
                  // style={{ top: "210px", width: "33%" }}
                >
                  {filteredLocation.length > 0 ? (
                    filteredLocation.map((p, idx) => (
                      <p
                        key={idx}
                        onClick={() => {
                          setSelectedLocations(p);
                          setShowLocations(false);
                          setSearchTerm("");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {p}
                      </p>
                    ))
                  ) : (
                    <p>No Location found</p>
                  )}
                </div>
              )}
            </div>
            <label>
              New Date:
              <input
                type="date"
                value={newDate}
                min={startDate}
                onChange={(e) => setNewDate(e.target.value)}
              />
            </label>
            <div className="time-slots">
              {timeSlots === null || timeSlots.length === 0 ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "var(--primary-color)",
                    fontWeight: "bolder",
                    marginTop: "30px",
                  }}
                >
                  No schedule found for selected date.
                </p>
              ) : (
                timeSlots.map((slot, index) => {
                  const isDisabled =
                    slot.status === "booked" || slot.status === "unavailable";
                  const tooltipMessage =
                    slot.status === "booked"
                      ? "This slot is already booked"
                      : slot.status === "unavailable"
                      ? "This slot is unavailable"
                      : "";
                  return (
                    <button
                      key={index}
                      disabled={isDisabled}
                      onClick={() => !isDisabled && setSelectedTime(slot.time)}
                      className={`slot-btn ${
                        selectedTime === slot.time ? "selected" : ""
                      } ${isDisabled ? "disabled-slot" : ""}`}
                      title={tooltipMessage}
                    >
                      {slot.time}
                    </button>
                  );
                })
              )}
            </div>
            <div className="popup-btns">
              <button onClick={handleEditSubmit}>Update</button>
              <button
                onClick={() => {
                  setShowEditPopup(false);
                  setAppointmentToEdit(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentDetail;
